import { z } from "zod";

export const ServiceLocationSchema = z.object({
  id: z.string().cuid().optional(),
  name: z.string().min(1),
  address: z.string().nullable().optional(),
  details: z.string().nullable().optional(),
});

export type ServiceLocationDto = z.infer<typeof ServiceLocationSchema>;

